import type {RunHistoryKeyInfoKeys, RunHistoryKeyType} from '../../types/run';
import * as RunHelpers from '../../util/runhelpers';
import {
  CES_EVAL_TABLE_HISTORY_TYPE,
  type EvalTableType,
  evalTableTypeQualifiedKey,
  LEGACY_EVAL_TABLE_HISTORY_TYPE,
} from './common';

export const getEnabledEvaluationTableTypes = (
  keyInfo: RunHistoryKeyInfoKeys[string],
  dominantType: RunHistoryKeyType | undefined,
  includeLegacyEvalTables: boolean,
  includeCesEvalTables: boolean
): EvalTableType[] => {
  if (
    dominantType !== LEGACY_EVAL_TABLE_HISTORY_TYPE &&
    dominantType !== CES_EVAL_TABLE_HISTORY_TYPE
  ) {
    return [];
  }

  const types: EvalTableType[] = [];
  for (const typeCount of keyInfo.typeCounts ?? []) {
    if (
      includeLegacyEvalTables &&
      typeCount.type === LEGACY_EVAL_TABLE_HISTORY_TYPE
    ) {
      types.push(LEGACY_EVAL_TABLE_HISTORY_TYPE);
    } else if (
      includeCesEvalTables &&
      typeCount.type === CES_EVAL_TABLE_HISTORY_TYPE
    ) {
      types.push(CES_EVAL_TABLE_HISTORY_TYPE);
    }
  }
  return types;
};

export const getEvaluationTablePanelKeys = (
  keys: RunHistoryKeyInfoKeys,
  includeLegacyEvalTables: boolean,
  includeCesEvalTables: boolean
): string[] => {
  if (!includeLegacyEvalTables && !includeCesEvalTables) {
    return [];
  }

  const keyTypes = RunHelpers.keyTypes(keys);
  const panelKeys: string[] = [];
  for (const [historyKey, keyInfo] of Object.entries(keys)) {
    for (const type of getEnabledEvaluationTableTypes(
      keyInfo,
      keyTypes[historyKey],
      includeLegacyEvalTables,
      includeCesEvalTables
    )) {
      panelKeys.push(evalTableTypeQualifiedKey(historyKey, type));
    }
  }
  return panelKeys;
};
